/* import __COLOCATED_TEMPLATE__ from './ic-legacy-modal-footer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();